export default "__VITE_ASSET__DQGx9fnS__"